import * as React from 'react';
import { ICON_SIZE_MAP } from '../helpers/size.js';
const AdminIcon = React.forwardRef((props, ref) => {
    const sizeKey = props.size !== undefined ? props.size : 1;
    const size = ICON_SIZE_MAP[sizeKey];
    return (React.createElement("svg", { width: size, height: size, fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, viewBox: "0 0 16 16" },
        React.createElement("path", { d: "M8.884 4.616c.234.235.366.552.366.884V7h-2.5V5.5a1.25 1.25 0 0 1 2.134-.884Z", fill: "currentColor" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m8.165.014 6 1A1 1 0 0 1 15 2v7A7 7 0 1 1 1 9V2a1 1 0 0 1 .835-.986l6-1c.11-.018.22-.018.33 0Zm3.542 11.693A1 1 0 0 0 12 11V8a1 1 0 0 0-1-1h-.25V5.5a2.75 2.75 0 1 0-5.5 0V7H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 .707-.293Z", fill: "currentColor" })));
});
AdminIcon.displayName = 'AdminIcon';
export default AdminIcon;
